// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","AdsCarousel":"_3oHNm7","AdBox":"_1a8JPZ","AdPackshot":"_1RJKAR","AdDescription":"_1LLYxR","fadeInFrames":"-YY76Z"};